/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// useStrict
/* global aBoothClick, mBoothClick, rBoothClick  */
var simpleDrawing;

expocadfx.Floorplan = function() {
    //var eventDatabaseName = "19ces";
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var txt = expocadfx.txt;
    var fxStyle = expocadfx.styles;
	var util = expocadfx.util;
    var Booth = expocadfx.Booth;
    var Drawing = expocadfx.Drawing;
    var Drawing3d = expocadfx.Drawing3d;
    var FxEvent = expocadfx.fxevent;
    var GraphicObject = expocadfx.GraphicObject;
    var MiniMap = expocadfx.MiniMap;
    
    var BOOTH_AVAILABLE = "0";
    var BOOTH_HOLD = "1";
    var BOOTH_RENTED = "2";
    var BOOTH_DELETED = "4";
    
    var twoD = null;
    var threeD = null;
	var drawing = null;
    var sales = null;
    var miniMap = null;
    var doc = document;
    
    var fpc = null;
    var flyout = null;
    var threedflyout = null;
    
    var touchStartTime = 0;
    var lastTapTime = 0;
    var lastTouchX = 0;
    var lastTouchY = 0;
    var dragging = false;       // panning
    var zooming = false;
    var bTextDone = false;
    var lastDist = -1;
    var pointerEvents = [];
    
    var fpcHeight = 0;
    var fpcWidth = 0;
    var zoomStep = 0.1;
    var bBuildingText = false;
    var bProcessPending = true;
    var totalElements = 0;
    var elementsDone = 0;
    var loopSize = 50;
    var clickCount = 0;
	var techLayersPending = false;
    
    var buildingImage = null;
    var xmlBooths = null;
    
    var bPointerDown = false;
    var lastBooth = null;

    var flyoutPending = false;
    var flyoutDelay = null;
    var fpRight = 0;
    var fpBottom = 0;

    var locationTimeoutID = 2;
    
	
	doc.addEventListener( "Technical_Layers_Loaded", techLayersLoaded);
    
    function getDistance( touch1, touch2) {
        return Math.sqrt(Math.pow((touch2.clientX - touch1.clientX), 2) + 
                                         Math.pow((touch2.clientY - touch1.clientY), 2)); 
    }
    
    function getBoothColor( graphic, status) {
        //  Option to use EXPOCAD booth color for line or fill
        if (status === 0 || status === BOOTH_AVAILABLE) {
            graphic.fillColor = config.fillAvailableWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrAvailable;
            
            graphic.strokeColor = config.borderAvailableWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else if (status === 1 || status === BOOTH_HOLD) {
            graphic.fillColor = config.fillOnHoldWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrHold;
            
            graphic.strokeColor = config.borderOnHoldWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else if (status === 2 || status === BOOTH_RENTED) {
            graphic.fillColor = config.fillRentedWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrRent;
            
            graphic.strokeColor = config.borderRentedWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else {    // ?? what is it ??
            graphic.fillColor = "white";
            graphic.strokeColor = "white";
        }
    }
    
    function getBoothMinMax( graphic) {
        var i = 0;
        graphic.minX = graphic.path[0].x;
        graphic.minY = graphic.path[0].y;
        graphic.maxX = graphic.path[0].x;
        graphic.maxY = graphic.path[0].y;

        for( i = 1; i < graphic.numPoints; i++) {
            graphic.minX = (graphic.path[i].x < graphic.minX) ? graphic.path[i].x : graphic.minX;
            graphic.minY = (graphic.path[i].y < graphic.minY) ? graphic.path[i].y : graphic.minY;
            graphic.maxX = (graphic.path[i].x > graphic.maxX) ? graphic.path[i].x : graphic.maxX;
            graphic.maxY = (graphic.path[i].y > graphic.maxY) ? graphic.path[i].y : graphic.maxY;
        }
            // probable bad show, BUT 2011 CES had 10 "booths" with 4 identical points
            //    3d throws exception!
        if( graphic.minX === graphic.maxX || graphic.minY === graphic.maxY) {
            graphic.hasSize = false;
        }
    }
    
    function newBooth( boothNumber) {
        var booth = new Booth( null, data.booths.length);
        booth.number = boothNumber;
        booth.graphic = new GraphicObject( null, "T");
        booth.graphic.index = data.booths.length;
        booth.graphic.fill = true;
        booth.graphic.stroke = true;
        booth.graphic.alpha = config.BOOTH_ALPHA;
        
        getBoothColor( booth.graphic, BOOTH_AVAILABLE);
        
        data.booths.push( booth);
        data.boothGraphics.push( booth.graphic);
        
        return booth;
    }
    
    function saveNewBooth( booth) {
        data.booths.push( booth);
        data.boothGraphics.push( booth.graphic);
    }
    
    function parseGraphicsXml( xml, start) {
        var end = (start + loopSize < totalElements) ? start +loopSize: totalElements;
        
        var i = 0;
        var booth = null;
        var graphic = null;
        var type = "";
		var arc = null;
        
        for( i = start; i < end; i++) {
            //  all graphic objects - booths, pavilions, graphics
            type = xml[i].getAttribute("b");
			
			if( type === "C") {
				data.arCircles.push( makeCircle( xml[i], type));
			}
			else if( type === "A") {
				arc = makeCircle( xml[i], type);
				arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
				arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
				data.arArcs.push( arc);
			}
			else {
				graphic = new GraphicObject( xml[i], type);

				if( type !== "T") {
					drawing.addGraphic(graphic);
				}
				else {
					getBoothMinMax( graphic);
					booth = new Booth( xml[i], data.booths.length);
					if( booth.status === BOOTH_AVAILABLE) {
						data.numAvailableBooths += 1;
					}
					else if( booth.status === BOOTH_HOLD) {
						data.numOnHoldBooths += 1;
					}
					getBoothColor( graphic, booth.status);
					graphic.displayColor = graphic.fillColor;
					booth.graphic = graphic;

					graphic.index = booth.index;

					data.booths.push( booth);
						// 2D or 3D
					drawing.addBoothGraphic( graphic);
					data.boothGraphics.push( graphic);
				}
			}
		}
    }
	
	function makeCircle( xml, type) {
		return {
			type: type,
			x: parseInt( xml.getAttribute( "x"), 10),
			y: parseInt( xml.getAttribute( "y"), 10),
			radius: parseFloat( xml.getAttribute( "r")),
			startAngle: 0,
			endAngle: 2 * Math.PI,
			lineWidth: 2 * parseInt( xml.getAttribute( "w"), 10),
			strokeColor: xml.getAttribute( "c").replace( "0x", "#"),
			alpha: 1,
			anticlockwise: false
		};
    }
    
    function makeJsonCircle( json, type) {
		return {
			type: type,
			x: parseInt( json.x, 10),
			y: parseInt( json.y, 10),
			radius: parseFloat( json.r),
			startAngle: 0,
			endAngle: 2 * Math.PI,
			lineWidth: 2 * parseInt( json.w, 10),
			strokeColor: json.colorOverride,
			alpha: 1,
			anticlockwise: false
		};
	}
    
    function removeBoothText( bth) {
		var exhId = data.exhibitors[bth.exhibitorIndex].exhId;
        drawing.removeBoothText( bth);
		
		doc.dispatchEvent( new FxEvent( "Favorite_Change", { fav:false, 
															boothNumber:bth.number,
															boothIndex:bth.index,
															exhId:exhId,
															local:true
															}));
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", {}));
    }
    
	function createFloorPlanObjects() {
		if( buildingImage === null) {
			getBuildingImage( config.eventName);
		}
        if( elementsDone < totalElements) {
            if( config.isXML){
                parseGraphicsXml( xmlBooths, elementsDone);
            }
            elementsDone += loopSize;
			loopSize += 100;		// shorter initial loop allows building jpeg to start loading sooner
        }
        else if( !bTextDone) {      // Pavilion name and any other non-booth text(?)
            
            if( config.isXML){
                addText( data.xmlGraphics.querySelectorAll( "PT"), data.pavilionLabels,
                    config.clrBoothText, config.FLOOR_PLAN_FONT);

                addText( data.xmlGraphics.querySelectorAll( "OT"), data.floorPlanText,
                    config.clrBoothText, config.FLOOR_PLAN_FONT);
            }
            else{
                parseGraphicsSQL();
            }
        
            bTextDone = true;
        }
        else if( !bBuildingText) {
			if( data.xmlBldgTxt && config.isXML) {
				addText( data.xmlBldgTxt, data.buildingText,
							config.clrBuildingText, config.FLOOR_PLAN_FONT);
				
				bBuildingText = true;
				data.status.buildingTextReady = true;
				bProcessPending = false;
				data.xmlBldgTxt = null;
            }
            else if( data.jsonBldgTxt){
                addJsonText( data.jsonBldgTxt, data.buildingText,
                    config.clrBuildingText, config.FLOOR_PLAN_FONT);
                
                bBuildingText = true;
                data.status.buildingTextReady = true;
                bProcessPending = false;
                data.jsonBldgTxt = null;
            }
        }
        
        if( bProcessPending) {
            setTimeout( createFloorPlanObjects, 0);
            drawing.redraw();
        }
        else {
            data.xmlGraphics = null;
            xmlBooths = null;
            
            enableEvents();
            data.status.boothObjectsReady = true;
            
            if( miniMap) {
                miniMap.setup();
            }
            drawing.completeSetup();
            elemById( "load").style.opacity = 0;
			
			if( techLayersPending) {
				processTechLayers();
			}
        }
    }
    
        // IN PROGRESS...
        function parseGraphicsSQL() {
            
            var BOOTH_COORDS = jsonGraphics.booths;
            var pavilions = jsonGraphics.pavilions;

            var i = 0;
            var booth = null;
            var graphic = null;
            var type = "";
            var arc = null;
    
            // Booths
            for (var i = 0; i < BOOTH_COORDS.length; i++) {

                type = 'T';
                graphic = new GraphicObject(null, type, BOOTH_COORDS[i]);
                getBoothMinMax(graphic);
    
                booth = new Booth(null, data.booths.length, BOOTH_COORDS[i]);
                if( booth.status === BOOTH_AVAILABLE) {
                    data.numAvailableBooths += 1;
                }
                else if( booth.status === BOOTH_HOLD) {
                    data.numOnHoldBooths += 1;
                }
                
                getBoothColor( graphic, booth.status);
                graphic.displayColor = graphic.fillColor;
                //graphic.displayColor = "#ADD8E6"; //Hard coded blue
                booth.graphic = graphic;
                graphic.index = booth.index;
                data.booths.push(booth);
                // 2D or 3D
                drawing.addBoothGraphic(graphic);
                data.boothGraphics.push(graphic);
            }

            i = 0;

            // Pavilions
            for (var i=0; i < pavilions.length; i++){
                
                type = 'P';
                graphic = new GraphicObject( null, type, pavilions[i]);
                drawing.addGraphic(graphic);
            }


            // Additional Graphics? - may have been moved to technical layers..
            // if( type === "C") {
			// 	data.arCircles.push( makeCircle( xml[i], type));
			// }
			// else if( type === "A") {
			// 	arc = makeCircle( xml[i], type);
			// 	arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
			// 	arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
			// 	data.arArcs.push( arc);
			// }
			// else {
			// 	graphic = new GraphicObject( xml[i], type);

			// 	if( type !== "T") {
			// 		drawing.addGraphic(graphic);
            //     }
            // }

            // Clear graphics from memory 
            //jsonGraphics = null;


            // TEMP 
        // var end = (start + loopSize < totalElements) ? start +loopSize: totalElements;
        
        // var i = 0;
        // var booth = null;
        // var graphic = null;
        // var type = "";
		// var arc = null;
        
        // for( i = start; i < end; i++) {
        //     //  all graphic objects - booths, pavilions, graphics
        //     type = xml[i].getAttribute("b");
			
		// 	if( type === "C") {
		// 		data.arCircles.push( makeCircle( xml[i], type));
		// 	}
		// 	else if( type === "A") {
		// 		arc = makeCircle( xml[i], type);
		// 		arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
		// 		arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
		// 		data.arArcs.push( arc);
		// 	}
		// 	else {
		// 		graphic = new GraphicObject( xml[i], type);

		// 		if( type !== "T") {
		// 			drawing.addGraphic(graphic);
		// 		}
		// 		else {
		// 			getBoothMinMax( graphic);
		// 			booth = new Booth( xml[i], data.booths.length);
		// 			if( booth.status === BOOTH_AVAILABLE) {
		// 				data.numAvailableBooths += 1;
		// 			}
		// 			else if( booth.status === BOOTH_HOLD) {
		// 				data.numOnHoldBooths += 1;
		// 			}
		// 			getBoothColor( graphic, booth.status);
		// 			graphic.displayColor = graphic.fillColor;
		// 			booth.graphic = graphic;

		// 			graphic.index = booth.index;

		// 			data.booths.push( booth);
		// 				// 2D or 3D
		// 			drawing.addBoothGraphic( graphic);
		// 			data.boothGraphics.push( graphic);
		// 		}
		// 	}
		// }
        }
    
    
    function addText( xml, arr, color, fontFamily) {
        var i = 0;
        var numText = xml.length;
        for( i = 0; i < numText; i++) {
            arr.push( util.textFromXML( xml[i], color, fontFamily));
        }
    }

    function addJsonText( jsonObject, arr, color, fontFamily) {
        var i = 0;
        var numText = jsonObject.length;
        for( i = 0; i < numText; i++) {
            arr.push( util.textFromJSON( jsonObject[i], color, fontFamily));
        }
    }
    
    function getBuildingImage( eventName) {
        if( data.notOldios) {
            buildingImage = doc.createElement( "img");

            if( config.isXML){
                buildingImage.src = (config.hasMultipleViews && config.hasFloorPlan) ?
                    config.viewName + ".jpg" : eventName + ".jpg";
            }
            else{
                buildingImage.src = (config.hasMultipleViews && config.hasFloorPlan) ?
                    eventDatabaseName + ".png" : eventDatabaseName + ".png";
            }

            buildingImage.onload = function() {
                drawing.addBuilding( buildingImage);
                if( miniMap) {
                    miniMap.addBuilding( buildingImage);
                }
            };
        }
    }
	
	function techLayersLoaded() {
		doc.removeEventListener( "Technical_Layers_Loaded", techLayersLoaded);
		if( data.status.boothObjectsReady) {
			processTechLayers();
		}
		else {
			techLayersPending = true;
		}
	}
	
	function processTechLayers() {
        if ( config.isXML) {
            var xmlGroups = data.xmlTechLayers.querySelectorAll( "Group");
            var xmlGraphics = null;
            var newGroup = null;
            var addGraphic = null;
            var len = xmlGroups.length;
            var i = 0;
            // technical layers
            for( i = 0; i < len; i++) {
                newGroup = {
                    id: i,
                    name: xmlGroups[i].getAttribute( "n"),
                    visible: false,
                    graphics: [],
                    txt: []
                };
                
                xmlGraphics = xmlGroups[i].querySelectorAll( "S");
                
                xmlToObjects( xmlGraphics, newGroup);
                
                addText( xmlGroups[i].querySelectorAll( "OT"), newGroup.txt,
                                config.clrBuildingText, config.FLOOR_PLAN_FONT);

                data.arTechLayers.push( newGroup);
            }
            // user added graphics
            addGraphic = data.xmlTechLayers.querySelector( "AddGraph");
            if( addGraphic && addGraphic.childElementCount > 0) {
                data.addedGraphics = {
                    graphics: [],
                    txt: []
                };
                
                xmlGraphics = addGraphic.querySelectorAll( "S");
                
                xmlToObjects( xmlGraphics, data.addedGraphics);
                
                addText( addGraphic.querySelectorAll( "OT"), data.addedGraphics.txt,
                                config.clrBoothText, config.FLOOR_PLAN_FONT);
            }
        }
        else {
            var jsonGroups = data.jsonTechLayers;
            var jsonGraphics = null;
            var jsonLayerGraphics = null;
            var newGroup = null;
            var addGraphic = null;
            var len = jsonGroups.length;
            var i = 0;
            // technical layers
            for( i = 0; i < len; i++) {
                newGroup = {
                    id: i,
                    name: jsonGroups[i].n, //.name?
                    visible: false,
                    graphics: [],
                    txt: []
                };
        
        jsonLayerGraphics = jsonGroups[i].graphics;
        
        jsonToObjects( jsonLayerGraphics, newGroup);

        addJsonText( jsonGroups[i].texts, newGroup.txt,
                        config.clrBuildingText, config.FLOOR_PLAN_FONT);

        data.arTechLayers.push( newGroup);
    }
    // user added graphics
    addGraphic = data.jsonGraphics;
    if( addGraphic && data.jsonGraphics.graphics.length > 0) {
        data.addedGraphics = {
            graphics: [],
            txt: []
        };
        
        jsonGraphics = addGraphic.graphics;
        
        jsonToObjects( jsonGraphics, data.addedGraphics);
        
        addJsonText( addGraphic.texts, data.addedGraphics.txt,
                        config.clrBoothText, config.FLOOR_PLAN_FONT);
    }
}		
		drawing.redraw();
		doc.dispatchEvent( new FxEvent( "Technical_Layer_Ready", null));
	}
	
	function xmlToObjects( xmlGraphics, obj) {
		var type = "";
		var newGraphic = null;
		var len = xmlGraphics.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
			// path, arc, circle  
			type = xmlGraphics[i].getAttribute("b");

			if( type === "C") {
				newGraphic = makeCircle( xmlGraphics[i], type);
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else if( type === "A") {
				newGraphic = makeCircle( xmlGraphics[i], type);
				newGraphic.startAngle = parseFloat( xmlGraphics[i].getAttribute( "s"));
				newGraphic.endAngle = parseFloat( xmlGraphics[i].getAttribute( "e"));
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else {
				newGraphic = new GraphicObject( xmlGraphics[i], "F");
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
		}
    }
    
    function jsonToObjects( jsonGraphics, obj) {
		var type = "";
		var newGraphic = null;
		var len = jsonGraphics.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
            
            // Only include booth layout objects if in Contractor mode
            if( jsonGraphics[i].bl > 0 ){
                if( config.salesMode !== "contra"){
                    continue;
                }
            }
            
            // path, arc, circle  
			type = jsonGraphics[i].b;

			if( type === "C") {
				newGraphic = makeJsonCircle( jsonGraphics[i], type);
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else if( type === "A") {
				newGraphic = makeJsonCircle( jsonGraphics[i], type);
				newGraphic.startAngle = parseFloat( jsonGraphics[i].s);
				newGraphic.endAngle = parseFloat( jsonGraphics[i].e);
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else {
				newGraphic = new GraphicObject( null, "F", jsonGraphics[i]);
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
		}
	}
	
    function zoomToBoothIndex( str, markBooth) {
        var arBooths = String(str).split( ",");
        var bthGraphic = null;
        var i = 0;
        var minX = config.DRAWING_WIDTH;
        var minY = config.DRAWING_HEIGHT;
        var maxX = 0;
        var maxY = 0;
		var newScale = 0;
		
		var margin = 0.2 * config.DRAWING_HEIGHT;	// maximum space around selected
		
		var selectedWidth = 0;
		var selectedHeight = 0;
		var selectedX = 0;
		var selectedY = 0;
        
        var canvas = document.getElementsByTagName('canvas')[3]
        var ctx = canvas.getContext('2d');
       // var radius = 70;
  
		
        if( arBooths.length > 0) {
            for( i = 0; i < arBooths.length; i++) {
                bthGraphic = data.boothGraphics[arBooths[i]];
                minX = Math.min( minX, bthGraphic.minX);
                minY = Math.min( minY, bthGraphic.minY);
                
                maxX = Math.max( maxX, bthGraphic.maxX);
                maxY = Math.max( maxY, bthGraphic.maxY);
                
                if( markBooth) {
                    drawing.markSelected( bthGraphic);
                }
            }
            
			selectedWidth = Math.max( maxX - minX, config.MULTIPLIER * config.scaleFactor);
			selectedHeight = Math.max( maxY - minY, config.MULTIPLIER * config.scaleFactor);
			
			margin = 2 * Math.min( Math.max( selectedWidth, selectedHeight), margin);
			
            //  ****  zoom less if one (great) big booth ??!!
            newScale = Math.min( fpcWidth / ( selectedWidth + margin), 
                                fpcHeight / ( selectedHeight + margin) );
                                                    
            selectedX = Math.round((maxX + minX) / 2);
            selectedY = Math.round((maxY + minY) / 2);

         //   ctx.beginPath();
      //      ctx.arc(selectedX, selectedY, radius, 0, 2 * Math.PI, false);
        //    ctx.fillStyle = 'green';
        //    ctx.fill();
        //    ctx.lineWidth = 500;
      //      ctx.strokeStyle = '#003300';
        //    ctx.stroke();   
            
            drawing.goToPoint( selectedX, selectedY, newScale);
        }
    }
    
    function zoomToIAmHere( x, y, label) {   // only at open event - center is middle of floor plan!
        var scale = drawing.getScale();
        var cax = parseInt( x, 10);
        var cay = parseInt( y, 10);
			// initial center of drawing
        drawing.moveBy( (config.DRAWING_WIDTH/2 - cax), ( config.DRAWING_HEIGHT/2 - cay));
        
        drawing.setIAmHere( String.fromCharCode(0xf140), label, x, y, config.clrHighlight);
        drawing.zoomTo( 0.6 - scale);
    }
    
    function tagBooth( boothIndex) {        //  Favorite   //
        if( twoD) {
            twoD.markFavorite( boothIndex);
        }
        if( threeD) {
            threeD.markFavorite( boothIndex);
        }
    }
    
    function clearBooth( type, boothIndex) {
        var arBoothIndex = String(boothIndex).split( ",");
        var i = 0;
        
        for( i = 0; i < arBoothIndex.length; i++) {
			if( twoD) {
				twoD.removeFavorite( arBoothIndex[i]);
			}
			if( threeD) {
				threeD.removeFavorite( arBoothIndex[i]);
			}
        }
    }
    
    function markFavorites() {
        var i = 0;
        var index = 0;
        var numFavs = data.favoriteBooths.length;
        var numBths = data.booths.length;
        
        for( i = 0; i < numFavs; i++) {
            for( index = 0; index < numBths; index++) {
                if( data.booths[ index].number === data.favoriteBooths[i].bth) {
                    drawing.markFavorite( index);
                    break;
                }
            }
        }
		if( drawing) {
			drawing.redraw( true);
		}
    }
    
    function outlineBooth( boothObj) {
        //  keep track of booths outlined ?
        drawing.addToOutline( boothObj, config.clrSelected, 12);
    }
    
    function unOutlineBooth( boothNum) {
        if( boothNum === null) {
            drawing.removeFromOutline( null);
        }
        else {
            var boothObj = util.findBoothObject( boothNum, data.booths);
            drawing.removeFromOutline( data.boothGraphics[ boothObj.index]);
        }
    }
    
    
 //-------------------------   EVENTS -----------------------------------------------------   
    function enableEvents() {
        if( config.bToolbar) {
            if( elemById("tb2") !== null) {
                    //  floor plan plus button
                elemById("tb2").addEventListener("click", function(){
                    drawing.zoom(2);
                });
                    // floor plan minus button
                elemById("tb3").addEventListener("click", function(){
                    drawing.zoom(-2);
                });
           }
                //   clear selected booths 
            doc.getElementById("tb4").addEventListener("click", function(){
                drawing.removeAllSelected();
            });

            doc.getElementById("tb5").addEventListener("click", fitDrawing);

            if( elemById("tb6") !== null) {
                doc.getElementById("tb6").addEventListener("click", function(){
            
                if( location.protocol === 'https:'){
                    if( config.locationEnabled){
                                        
                        config.locationEnabled = false;
                        elemById("tb6").style.backgroundColor = "#dcdcdc";

                        drawing.clearIAmHere();
                        drawing.redraw(true);

                        clearInterval(locationTimeoutID);
                    }
                    else{
                        getLocation();
                    }
                }
                else{
                        if(confirm("Location Services requires HTTPS.  Reload as secure site?")){
                            window.location.href ="https://" + location.hostname + location.pathname;
                        }
                    }

                });
            }
        }
        
        elemById( "floorplan").addEventListener( "wheel", wheelHandler);
        
        function wheelHandler(evt) {
            evt.stopImmediatePropagation();
            evt.preventDefault();

            if (evt.deltaY < 0){
               
               if( drawing != threeD){
                drawing.zoomToCursor( zoomStep);
               }
               else{
                drawing.zoom( zoomStep);
               }
                
            }
            else {
                if( drawing != threeD){
                    drawing.zoomToCursor( -1 * zoomStep);
                   }
                   else{
                    drawing.zoom( -1 * zoomStep);
                   }
            }
        }
        
        doc.addEventListener( "Highlight_Booth", function( evt) {
            drawing.highlightBooth( evt.data.index);
        });
        
        doc.addEventListener( "Unhighlight_Booth", function() {
            drawing.highlightBooth( "-1");
        });
        
		if( !data.status.overlaysReady) {
			doc.addEventListener( "overlaysLoaded", function() {
				twoD.addOverlays();
				if( threeD) {
					threeD.addOverlays();
				}
			});
		}
		
        fpc.addEventListener("contextmenu", function(e) { e.preventDefault(); });

        if ( window.PointerEvent) {
            fpc.addEventListener('pointerdown', function(evt) {
                var i = 0;
                evt.preventDefault();
                pointerEvents.push( evt);
                
                if( !dragging && !zooming && pointerEvents.length < 2) {
                   
                    for( i = 0; i < pointerEvents.length; i++) {
                        if( evt.pointerId === pointerEvents[i].pointerId) {
                            pointerEvents[i] = evt;
                        }
                    }
                    
                    if( pointerEvents.length === 1) {
                        lastTouchX = evt.clientX;
                        lastTouchY = evt.clientY;
                        touchStartTime = Date.now();
                        bPointerDown = true;
                        drawing.pointerDownAt( evt.clientX, evt.clientY);
                        
                        doc.dispatchEvent( new FxEvent( "User_Activity", null));
                    }
                    else {
                        lastDist = getDistance( pointerEvents[0], pointerEvents[1]);
                    }
                }
            });

            fpc.addEventListener('pointermove', pointerMoveHandler);
            
            fpc.addEventListener('pointerup', function(evt) {
                evt.preventDefault();
//                console.log( "pointer up button: " + evt.button);
                var i;
                for( i = 0; i < pointerEvents.length; i++) {
                     if( evt.pointerId === pointerEvents[i].pointerId) {
                        pointerEvents.splice( i, 1);
                         break;
                    }
                }
                
                if( pointerEvents.length < 2) {
                    lastDist = -1;
                }
                if( pointerEvents.length === 0) {
                    if( !dragging && !zooming && evt.button === 0 && Date.now() - touchStartTime < 400) {
                        tapHandler( lastTouchX, lastTouchY);
                    }
                    dragEndHandler();
                }
            });
            fpc.addEventListener('pointerout', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('pointerleave', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('pointercancel', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('auxclick', function(evt) {
                if( evt.which === 2) {
                    fitClick(evt);
                }
            });
        }
        else {
            fpc.addEventListener('touchstart', function(evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                if( !dragging && !zooming) {
                    bPointerDown = true;
                    touchStartTime = Date.now();
                    
                    if( flyoutDelay) {
                        clearTimeout( flyoutDelay);     // does not remove booth highlight
                    }
                    if( evt.touches.length === 1) {
                        lastTouchX = evt.touches[0].clientX;
                        lastTouchY = evt.touches[0].clientY;
                        bPointerDown = true;
                        drawing.pointerDownAt( lastTouchX, lastTouchY);
                    }
                    else if( evt.touches.length > 1) {
                        lastDist = getDistance( evt.touches[0], evt.touches[1]);
                    }
                    fpc.addEventListener('touchmove', touchMoveHandler, false);
                }
                doc.dispatchEvent( new FxEvent( "User_Activity", null));
                return false;
            }, true);
            
            fpc.addEventListener('touchend', function(evt) {
                evt.preventDefault();
                evt.stopPropagation();
                evt.stopImmediatePropagation();
                
                fpc.removeEventListener('touchmove', touchMoveHandler, false);
                
                if( evt.touches.length === 0) {
                    if( !dragging && !zooming && Date.now() - touchStartTime < 400) {
                        tapHandler( lastTouchX, lastTouchY);
                    }
                    dragEndHandler();
                    lastDist = -1;
                }
            });
        
            if( data.device !== "ios" && data.device !== "A" ) {
                fpc.addEventListener('mousedown', function(evt) {
                    evt.preventDefault();
                    
                    if( evt.button === 0) {
                        lastTouchX = evt.clientX;
                        lastTouchY = evt.clientY;
                        bPointerDown = true;
                        drawing.pointerDownAt( evt.clientX, evt.clientY);
                        doc.dispatchEvent( new FxEvent( "User_Activity", null));
                    }
                });
                fpc.addEventListener('mouseup', function() {
                    dragEndHandler();
                });
                fpc.addEventListener('mousemove', function( evt) {
                    evt.preventDefault();
                    mouseMoveHandler( evt.clientX, evt.clientY);
                });
                fpc.addEventListener('mouseout', function() {
                    clearFlyoutAndHighlight();
                    dragEndHandler();
                });
                fpc.addEventListener('mouseleave', function() {
                    clearFlyoutAndHighlight();
                    dragEndHandler();
                });
                fpc.addEventListener( "click", function( evt) {
                    if( evt.button === 0) {
                        tapHandler( evt.clientX, evt.clientY);
                    }
                });
            }
		}  
    }
    
    function pointerMoveHandler( evt) {
        evt.preventDefault();
        var i;
        var currentDist = 0;
        
        if( pointerEvents.length === 0) {
            if( evt.pointerType === "mouse") {
                mouseMoveHandler( evt.clientX, evt.clientY);
            }
        }
        else {
            for( i = 0; i < pointerEvents.length; i++) {
                if( evt.pointerId === pointerEvents[i].pointerId) {
                    pointerEvents[i] = evt;
                }
            }
        }
        if( pointerEvents.length > 1) {
            currentDist = getDistance( pointerEvents[0], pointerEvents[1]);
            if( lastDist > 0) {
                pinchHandler( currentDist);
            }
            lastDist = currentDist;
        }
        else if( pointerEvents.length === 1) {
            mouseMoveHandler( evt.clientX, evt.clientY);
        }
    }
    
    function touchMoveHandler( evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        
        var touch1 = evt.touches[0];
        var touch2;
        
        if( evt.touches.length > 1) {
            touch2 = evt.touches[1];
            var dist = getDistance( touch1, touch2);
            
            if( lastDist > 0) {
                pinchHandler( dist);
            }
            lastDist = dist;
        }
        else if( evt.touches.length === 1) {
            dragHandler( touch1.clientX, touch1.clientY, false);
        }
        return false;
    }
    
    function pinchHandler( dist) {
        var change = dist - lastDist;
        
        if( change > 2 * window.devicePixelRatio) {  // and tm > 34mS
            lastTapTime = ( Date.now()) + 600;
            zooming = true;
            drawing.zoom( zoomStep);
        }
        else if( change < -2 * window.devicePixelRatio) {
            lastTapTime = ( Date.now()) + 600;
            zooming = true;
            drawing.zoom( -1 * zoomStep);
        }
        else {
            lastTapTime = Date.now();
            return;
        }
        lastDist = dist;
    }
    
    function dragEndHandler() {
        if( dragging) {
            dragging = false;
        }
        if( zooming) {
            zooming = false;
            drawing.redraw( true);
        }
        bPointerDown = false;
    }

    function fitClick(e){
            clickCount++;
            if (clickCount === 1) {
                singleClickTimer = setTimeout(function() {
                    clickCount = 0;
                }, 375);
            } else if (clickCount === 2) {
                clearTimeout(singleClickTimer);
                clickCount = 0;
                drawing.fit();
            }
    }
    
    function dragHandler( eventX, eventY) {
        var dx = 0;
        var dy = 0;
        if( zooming) {
            return; // Might be an issue when zoom to cursor is finished? 
        }
        if( bPointerDown) {
            dx = eventX - lastTouchX;
            dy = eventY - lastTouchY;
            
            if( dragging || Math.sqrt( dx * dx + dy * dy) > 5) {
                dragging = true;
                drawing.dragTo( eventX, eventY);
                lastTouchX = eventX;
                lastTouchY = eventY;
                
                lastTapTime = Date.now();
            }
        }
    }
    
    function tapHandler( eventX, eventY) {
        var ar = [];
        var tm = Date.now();
        var result = "1";
        var boothIndex = -1;
        var obj = null;
		
        var cursorX = eventX - elemById( "floorplan").offsetLeft;
        var cursorY = eventY - data.headerHeight;
           
        if( tm - lastTapTime < 340) {
            return;
        }
        lastTapTime = tm;
        if( flyoutPending) {
            clearTimeout( flyoutDelay);
            flyoutPending = false;
        }
//        console.log( "Floor Plan Tap Handler - menuPending: " + data.menuPending);
        if( data.menuPending || data.iahPending) {
			document.dispatchEvent( new FxEvent( "Floor_Plan_Tap", { pageX: cursorX, pageY: cursorY}) );
			if ( data.iahPending) {
                data.iahPending = false;
				return;
			}
        }
        if(config.salesMode === "exhibitor"){    
            var parent = document.querySelector('#floorplan')
            var cart = doc.createElement('div');            
            var legendFinish = doc.createElement('p')
            cart.setAttribute('id', 'cartLegend');
            cart.style.display = 'none';
            parent.insertAdjacentElement("afterend", cart)
            cart.innerHTML = "<i id='cartIcon'class='fas fa-shopping-cart'></i> Cart";
            legendFinish.setAttribute("id", "legendFinish");
            legendFinish.textContent = "Check Out";
            cart.appendChild(legendFinish);
        }
        if(config.salesMode === "exhibitor"){
            var Parent = elemById('appContent');
            var Modal = doc.createElement('div');
            Modal.setAttribute("id", "buyModal");
            Modal.classList.add('modal');
            Parent.appendChild(Modal);

            var ModalContent = doc.createElement('div');
            ModalContent.classList.add('modal-content');
            Modal.appendChild(ModalContent);

            var ModalH3 = doc.createElement('h3');
            ModalContent.appendChild(ModalH3);
            ModalH3.textContent = "Rent This Booth?"

            var ModalP = doc.createElement('p');
            ModalP.setAttribute('id', 'ModalP');
            ModalContent.appendChild(ModalP);

            var ModalFooter = doc.createElement('div');
            ModalFooter.setAttribute('id', 'modalFooter')
            ModalContent.appendChild(ModalFooter);

            var ModalConfirm = doc.createElement('button');
            ModalConfirm.setAttribute('id', 'modalConfirm')
            ModalFooter.appendChild(ModalConfirm);
            ModalConfirm.textContent = "Check Out";

            var ModalContinue = doc.createElement('button');
            ModalContinue.setAttribute('id', 'modalContinue')
            ModalFooter.appendChild(ModalContinue);
            ModalContinue.textContent = "Rent Another";

            var ModalCancel = doc.createElement('button');
            ModalCancel.setAttribute('id', 'modalCancel')
            ModalFooter.appendChild(ModalCancel);
            ModalCancel.textContent = "Cancel";
        }
        
        obj = drawing.hitTest( cursorX, cursorY);
        if( obj !== null) {
            if( obj.hasOwnProperty( "graphic")) {     // obj is a booth
                if( data.salesWindowOpen) {
                    doc.dispatchEvent( new FxEvent( "Booth_Click", obj));
                }
                else {
                    if( config.bUseApi) {
                        if( obj.status === "0" || config.salesMode === "contra") {
                            if(config.salesMode === "exhibitor"){
                                
                                if(config.showUnits === "M"){
                                var area = obj.areaM;
                                var dim = obj.dimM;
                                }
                                else
                                {
                                    var area = obj.areaF;
                                    var dim = obj.dimF;
                                }
                                ExhibitorRentBooth(obj, obj.number, dim, area)
                                result = 0; //stops popup when available booth is clicked
                            }
                            else if (config.salesMode === "contra"){
                                // Send contractor user to booth layout page
                                var boothUrl = doc.location.href.substr(0, doc.location.href.lastIndexOf("/"));
                                util.navigateTo( boothUrl + "/boothLayout?boothNumber=" + obj.number, "_parent" )

                                result = 0;
                            }
                            else{
                                result = aBoothClick( obj.number);
                            }
                            
 
                        }
                        else {
                            ar = obj.exhibitorIndex.toString().split( ",");
                            if( ar.length > 1) {
                                result = mBoothClick( obj.number);
                            }
                            else {
                                if(config.salesMode === "exhibitor"){
                                    window.parent.swal("", "Booth Not Available For Rent!", "warning");
                                    result = 0; //stops popup when available booth is clicked
                                } else {
                                    result = rBoothClick( obj.number,
                                                     data.exhibitors[obj.exhibitorIndex].exhId,
                                                     data.exhibitors[obj.exhibitorIndex].name);
                                    if( config.redirectToDirectory && !config.isXML){
                                        result = 0;
                                        util.navigateTo( doc.location.origin + data.exhibitors[obj.exhibitorIndex].directoryUrl);
                                    }
                                }
                            }
                        }
                    }
                    if( String(result) === "1") {
                        if( ar.length < 2 && data.exhibitors[obj.exhibitorIndex].url != "") {
                            util.navigateTo( data.exhibitors[obj.exhibitorIndex].url);
                        }
                        else {
                            doc.dispatchEvent( new FxEvent( "Floor_Plan_Booth_Click", obj));
                        }
                    }
                }
            }
            else {  //  obj is an overlay
                    //  if navTo && zoomTo, zoom first and delay navigation to see the zoom
                    if( obj.navTo !== "") {
                        if( obj.zoomTo === "") {
                            util.navigateTo( obj.navTo);
                        }
                        else {
                            window.setTimeout( util.navigateTo, 700, obj.navTo);
                        }
                    }
                    
                    if( obj.zoomTo !== "") {
                        boothIndex = util.findBoothIndex( obj.zoomTo, data.booths);
                        if( boothIndex !== -1) {
                            zoomToBoothIndex( String(boothIndex), true);
                            
                        }
                    }
                    // else if( obj.navTo !== "") {
                    //     util.navigateTo( obj.navTo);
                    // }


            }
        }
    }
    var otherBooths = [];
    function ExhibitorRentBooth(theObj, objNum, dim, area){
        var modal = document.getElementById('buyModal');
        var modalBody = elemById('ModalP');
        var confirmBut = elemById('modalConfirm');
        var cancelBut = elemById('modalCancel');
        var continueBut = elemById('modalContinue');
        var Next = parent.document.getElementById('theFloorplan');
        var NextDiv = parent.document.getElementById('CartBooths');
        var CartBooths = parent.document.createElement('div');
        var SelectedFP = parent.document.getElementsByClassName('overlay');
        var checkOut = elemById('legendFinish');
        var deleteSpan = doc.createElement('span');
        var cart = elemById('cartLegend');
        var legendite = doc.createElement('li');
        deleteSpan.setAttribute("class", "deleteEvent");
        deleteSpan.textContent = "x";
        theObj.show = config.eventName;

        modal.style.display = "block";  
        modalBody.textContent = "Booth #" + objNum + " - " + dim + " " + area;

        cancelBut.onclick = function() {
        modal.style.display = "none";
        }
        confirmBut.onclick = function(){
            if(otherBooths.find(obj => obj.number === theObj.number)
            &&  otherBooths.find(obj => obj.show === theObj.show)
            || parent.Booths.find(obj => obj.number === theObj.number) 
            && parent.Booths.find(obj => obj.show === theObj.show)){
                parent.swal("", "Booth already in your cart!", "warning");
            } else {
            NextDiv.appendChild(CartBooths);
            otherBooths.push(theObj);
            CartBooths.setAttribute('class', 'CartBoothsInner');
            parent.AddBooth(theObj.number, theObj.show, function(){
                console.log('added');
            });
            if (otherBooths !== undefined || otherBooths.length !== 0) {
                Array.prototype.push.apply(parent.Booths, otherBooths);
            }
            parent.console.log(parent.Booths);
            parent.singleShowAfterCheckout()
            for ( var i = 0; i < SelectedFP.length; i++ ) {
                SelectedFP[i].classList.remove( 'SelectedFloorplan' );
            }
            Next.style.boxShadow = "none";
            Next.setAttribute('src', '');
            NextDiv.style.display = "block";
            }
        }

        continueBut.onclick = function(){
            //ES6 syntax is being used. Namely .find() and arrow func
            if(otherBooths.find(obj => obj.number === theObj.number)
            &&  otherBooths.find(obj => obj.show === theObj.show)
            || parent.Booths.find(obj => obj.number === theObj.number) 
            && parent.Booths.find(obj => obj.show === theObj.show)){
                parent.swal("", "Booth Already in Your Cart!", "warning");
            } else {
                document.getElementById('ModalP').innerHTML = '<div id="spinner"></span>';
                parent.AddBooth(theObj.number, theObj.show, function(){
                    var legendFinish = elemById('legendFinish');
                    cart.style.display = 'block';
    
                    legendite.textContent = "Booth " + objNum;
                    legendite.setAttribute('class', objNum + theObj.show);
                    cart.insertBefore(legendite, legendFinish);
                    legendite.insertAdjacentElement('beforeend', deleteSpan);
                    deleteSpan.onclick = function(e){
                        e.stopPropagation
                        parent.swal("Success", "Booth removed from Cart", "success");
                        this.parentNode.remove();
                        var found = otherBooths.find(obj => obj.number === objNum);
                        otherBooths.splice(otherBooths.indexOf(found), 1);
                        parent.removeBooth(theObj.number, theObj.show);
                        parent.document.querySelector("[class='" + theObj.number + theObj.show + "boothSubTimer']").remove();
                        parent.document.querySelector("[class='" + theObj.number + theObj.show + "boothSubTimer']").remove();
                    }
                    otherBooths.push(theObj);
                    modal.style.display = "none";
                    document.getElementById('spinner').remove()
                    console.log(otherBooths); 
                    var timerInterval = setInterval(function(){
                        var el = document.querySelector("[class='" + theObj.number + theObj.show + "']");
                        if(!document.body.contains(el)){
                            var found = otherBooths.find(obj => obj.number === theObj.number);
                            otherBooths.splice(otherBooths.indexOf(found), 1);
                            console.log(otherBooths);
                            clearInterval(timerInterval);
                        }
                    }, 200);
                });
            }
        }
        checkOut.onclick = function(){
            NextDiv.appendChild(CartBooths);

            CartBooths.setAttribute('class', 'CartBoothsInner');
            parent.singleShowAfterCheckout()
            if (otherBooths !== undefined || otherBooths.length !== 0) {
                Array.prototype.push.apply(parent.Booths, otherBooths);
            }
            for ( var i = 0; i < SelectedFP.length; i++ ) {
                SelectedFP[i].classList.remove( 'SelectedFloorplan' );
            }
            Next.style.boxShadow = "none";
            Next.setAttribute('src', '');
            NextDiv.style.display = "block";
        }
        window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
            }
        }
    }

    
    function mouseMoveHandler( clientX, clientY) {
        var obj = null;
        var arExhIndex;
        var i;
        var flyoutText = "";
        var cursorX = clientX - elemById( "floorplan").offsetLeft;
        var cursorY = clientY - data.headerHeight;
        
        if( bPointerDown) {
            dragHandler( clientX, clientY);
        }
        else {
            
            // Avoid mouse interaction with booths when in simpleDrawing mode
            if( simpleDrawing == true){ return;}
            
            obj = drawing.hitTest( cursorX, cursorY);
            if( obj !== null) {
//                console.log( "Mouse move hit - obj: " + typeof(obj));
                if( obj === lastBooth) {
                    return;
                }
                if( obj.hasOwnProperty( "graphic")) {     // obj is a booth
                    drawing.highlightBooth( obj.index);
                    if( lastBooth === null || obj.number !== lastBooth.number) {
                        lastBooth = obj;
                        flyout.style.visibility = "hidden";
                        flyout.style.display = "block";

                        flyoutText = txt.BOOTH + " &nbsp;";
                        flyoutText += obj.number + "<br>";
                        if( config.units === "F") {
                            flyoutText += obj.dimF + "&nbsp;&nbsp;&nbsp;" + obj.areaF + "<br>";
                        }
                        else {
                            flyoutText += obj.dimM + "&nbsp;" + obj.areaM + "<br>";
                        }
                        if( obj.status === "0") {
                            flyoutText += txt.AVAILABLE;
                            if( obj.flyout !== "") {
                                flyoutText += "<br><br>" + obj.flyout;
                            }
                        }
                        else {
                            arExhIndex = obj.exhibitorIndex.toString().split(",");
                            //arExhIndex = obj.exhibitorIndex[0];
                            for( i = 0; i < arExhIndex.length; i++) {
                                if( i > 0) {
                                    flyoutText += "<br>";
                                }
                                
                                flyoutText += data.exhibitors[ arExhIndex[i] ].name;
                                //flyoutText += data.exhibitors[arExhIndex].name;
                                
                            }
                        }
                        flyout.innerHTML = flyoutText;
                    }
                }
                else {      // obj is an overlay
                    if( obj.toolTip !== "") {
 
                        flyout.style.visibility = "hidden";
                        flyout.style.display = "block";
                        
                        flyout.innerHTML = obj.toolTip;
                    }
                }
                
                flyoutPending = true;
                clearTimeout( flyoutDelay);
                flyoutDelay = setTimeout( showFlyout, 320); // wait for tap
                
                flyout.style.left = ( clientX + flyout.offsetWidth + 20 < fpRight) ?
                                    (cursorX + 16) + "px" : 
                                    (cursorX - flyout.offsetWidth - 16) + "px";

                flyout.style.top = ( clientY + flyout.offsetHeight + 20 < fpBottom) ?
                                    (cursorY + 16) + "px" : 
                                    (cursorY - flyout.offsetHeight) + "px";

            }
            else {
                clearFlyoutAndHighlight();
            }
        }
    }
    
    function clearFlyoutAndHighlight() {
        if( lastBooth !== null) {
            drawing.highlightBooth( "-1");
        }
        clearTimeout( flyoutDelay);
        flyout.style.display = "none";
        flyout.innerHTML = "";
        lastBooth = null;
    }
    
    function showFlyout() {
        flyout.style.display = "block";
        flyout.style.visibility = "visible";
    }
    
    function init() {
        fpcHeight = elemById("floorplan").clientHeight;
        fpcWidth = elemById("floorplan").clientWidth;
        fpc = elemById( "fpContainer");
        flyout = elemById( "flyout"); 

        flyout.style.backgroundColor = config.clrFlyoutBackground || config.clrHighlight;
        flyout.style.color = config.clrFlyoutText || "#ffffff";
		if( config.flyoutFontSize) {
			flyout.style.fontSize = config.flyoutFontSize;
        }
        if( config.bToolbar && config.salesMode === "none" && config.elvis === false && config.is3d === true && !data.smallLayout){	    						
            threedflyout = document.querySelector('.flyout-3d');
            threedflyout.style.backgroundColor = config.clrFlyoutBackground || config.clrHighlight;
            threedflyout.style.color = config.clrFlyoutText || "#ffffff";
            threedflyout.style.fontSize = config.flyoutFontSize;
        }
		//  always create 2d environment or Chrome 64 cpu usage spikes on change from 3d to 2d !
		twoD = new Drawing();
		
		if( config.is3d && config.openIn3D) {
			threeD = new Drawing3d();
			drawing = threeD;
		}
		else {
			drawing = twoD;
		}
		
		drawing.showFloorPlan();
		
        if( data.miniMap) {
            miniMap = new MiniMap( data.miniMap.content, drawing.getOffset());
                miniMap.enableNavigation();
        }
        
        zoomStep = 1;
        
        if( config.isXML){
            xmlBooths = data.xmlGraphics.getElementsByTagName("S");
            totalElements = xmlBooths.length;
        }
        
        createFloorPlanObjects();
        
        if( config.showCoords) {
            elemById( "coords").style.display = "block";
        }
        if( fpRight === 0) {
            fpRight = data.viewportWidth - 2;
            fpBottom = data.viewportHeight - elemById( "ftr").offsetHeight;
        }
        
    }

    if(!config.isXML && !config.noNav){
        function navbar() {
            var nav = document.getElementById('dirNavbarNav');
            var loc = window.location;
            var login = document.getElementById('directoryLogin');
            var directory = document.createElement('button');
            var floorplan = document.createElement('button');
            var category = document.createElement('button');

            var directoryA = document.createElement('a');
            var floorplanA = document.createElement('a');
            var categoryA = document.createElement('a');

            directoryA.appendChild(directory);
            floorplanA.appendChild(floorplan);
            categoryA.appendChild(category);

            directory.textContent = "Directory";
            floorplan.textContent = "Floorplan";
            category.textContent = "Categories";

            directory.classList.add("invertBtn");
            floorplan.classList.add("invertBtn");
            category.classList.add("invertBtn");

            directoryA.href = loc.protocol + "//" + loc.host + "/" + config.eventName + "/directory"
            categoryA.href= loc.protocol + "//" + loc.host + "/" + config.eventName + "/tags"
            login.href= loc.protocol + "//" + loc.host + "/"
            floorplan.disabled = true;

            nav.appendChild(directoryA);
            nav.appendChild(floorplanA)
            nav.appendChild(categoryA)    
            toggleFullScreen();
        }
        navbar();

        function toggleFullScreen() {
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        }
    }

    
    function windowResizeHandler() {
        var offset;
        fpcHeight = elemById("floorplan").clientHeight;
        fpcWidth = elemById("floorplan").clientWidth;
        fpRight = data.viewportWidth - 2;
        fpBottom = data.viewportHeight - elemById( "ftr").offsetHeight;
        
        if( drawing !== null) {
            offset = drawing.resizeHandler();
            drawing.redraw( true);
        }
        if( miniMap) {
            miniMap.resize( offset);
        }
    }
    
    function fitDrawing() {
        drawing.fit();
    }

    function getLocation() {
        if ( navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, showLocationError);
        }
        else {
            alert("Geolocation is not supported by this browser.");
        }
    }

    function showPosition(position) {
        
        drawing.clearIAmHere();

        var arFxCoords = gpsToFX(position.coords.latitude, position.coords.longitude)

        config.lastXY = arFxCoords;

        drawing.setIAmHere( String.fromCharCode(0xf140), "", arFxCoords[0],arFxCoords[1], config.clrHighlight);
        drawing.redraw(true);

        if( !config.locationEnabled){
            var bgColor = fxStyle.fpToolbar.clrBg !== "" ?
            fxStyle.fpToolbar.clrBg : fxStyle.floorplan.clrBg !== "" ?
            fxStyle.floorplan.clrBg : fxStyle.mainHeader.clrBg;

            var locationButton = elemById("tb6");
            locationButton.style.backgroundColor = bgColor;
            
            config.locationEnabled = true;

            locationTimeoutID = setInterval(getLocation, config.locationUpdateCheckInterval);
            
        }
        
    }

    function showLocationError(error) {
        switch(error.code) {
          case error.PERMISSION_DENIED:
            alert( "User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            alert( "Location information is unavailable.");
            break;
          case error.TIMEOUT:
            alert( "The request to get user location timed out.");
            break;
          case error.UNKNOWN_ERROR:
            alert( "An unknown error occurred.");
            break;
        }
      }

    function gpsToFX(latitude, longitude) {
        var coords;
        
        // Old values for testing based on my house :) -ANH
        var lat0 = parseFloat(config.refLat0); //41.700033;
        var lon0 = parseFloat(config.refLon0); //-88.341464;
        var lat1 = parseFloat(config.refLat1); //41.701947;
        var lon1 = parseFloat(config.refLon1); //-88.336517;
        
        var FXX0 = parseFloat(config.refFXX0); //1570.0;
        var FXY0 = parseFloat(config.refFXY0); //8375.0;
        var FXX1 = parseFloat(config.refFXX1); //16775.0;
        var FXY1 = parseFloat(config.refFXY1); //505.0;
    
        var radius = 110919.0;
        var d1 = (lat0 + lat1) / 2.0;
        var circumferenceAtLat = Math.cos(d1 * 0.01745329251) * 111305;
        var x0 = lon0 * circumferenceAtLat;
        var y0 = lat0 * radius;
        var x1 = lon1 * circumferenceAtLat;
        var y1 = lat1 * radius;

        if (false){ // Save the old code
            var d2 = (FXX1 - FXX0) / (x1 - x0);
            var d3 = (FXY1 - FXY0) / (y1 - y0);
    
            var x2 = longitude * circumferenceAtLat;
            var y2 = latitude * radius;
    
            var x = FXX0 + (x2 - x0) * d2;
            var y = FXY0 + (y2 - y0) * d3;
        }
        else{
            var d1 = x1 - x0;
            var d2 = y1 - y0;
            var d3 = Math.sqrt((d1 * d1) + (d2 * d2)); Math.sq
            var d4 = d2 / d3;
            var A1 = Math.asin(d4);		// Angle for GPS
        
            d1 = FXX1 - FXX0;
            d2 = FXY1 - FXY0;
            d3 = Math.sqrt((d1 * d1) + (d2 * d2));
            d4 = d2 / d3;
            var A2 = Math.asin(d4);		// Angle for FX
        
            var A3 = A1 - A2;
            var fx0 = FXX0;
            var fy0 = FXY0;
            var fx1 = fx0 + Math.cos(A3) * d1 - Math.sin(A3) * d2;		// rotate point to GPS
            var fy1 = fy0 + Math.sin(A3) * d1 + Math.cos(A3) * d2;
        
            d2 = (fx1 - fx0) / (x1 - x0);
            d3 = (fy1 - fy0) / (y1 - y0);
            A3 = A2 - A1;
        
            var x2 = longitude * circumferenceAtLat;
            var y2 = latitude * radius;
            
            x2 = x2 - x0;
            y2 = y2 - y0;
            var m1 = x2 * d2;
            var m2 = y2 * d3;	
        
            var x = fx0 + Math.cos(A3) * m1 - Math.sin(A3) * m2;		// rotate point to FX
            var y = fy0 + Math.sin(A3) * m1 + Math.cos(A3) * m2;
        }

        coords = [x, y];

        console.log("X: " + coords[0]);
        console.log("Y: " + coords[1]);
    
        return coords;
    }

    function show3d() {
        var ar;
        var tmp = drawing.getSelected();
        drawing.remove2d();
        if( threeD === null ) {    //  !threeD.getIsReady()
			threeD = new Drawing3d();
            drawing = threeD;
            drawing.completeSetup();
            drawing.addBuilding( buildingImage);
            markFavorites();
				//  only once ??
			if( data.queryCoord !== "") {
				ar = data.queryCoord.split( ",");
				zoomToIAmHere( ar[0], ar[1], txt.I_AM_HERE);
			}
        }
        else {
            drawing = threeD;
        }
		
        drawing.showFloorPlan();
        drawing.updateSelected( tmp);
        twoD.removeAllSelected();
        if( miniMap) {
            miniMap.resize( drawing.getOffset());
        }
        tmp = null;
    }
    
    function show2d() {
        var ar;
        var tmp = drawing.getSelected();
        drawing.remove3dFloorPlan();
        if( !twoD.getIsReady() ) {
            drawing = twoD;
            drawing.completeSetup();
            drawing.addBuilding( buildingImage);
            markFavorites();
				//  only once ??
			if( data.queryCoord !== "") {
				ar = data.queryCoord.split( ",");
				zoomToIAmHere( ar[0], ar[1], txt.I_AM_HERE);
			}
        }
        else {
            drawing = twoD;
        }
        
		drawing.showFloorPlan();
        drawing.updateSelected( tmp);
        threeD.removeAllSelected();
        if( miniMap) {
            miniMap.resize( drawing.getOffset());
//            miniMap.enableNavigation();
        }
		drawing.redraw();
        tmp = null;
    }
    
        
    return {
        BOOTH_AVAILABLE : BOOTH_AVAILABLE,
        BOOTH_DELETED : BOOTH_DELETED,
        BOOTH_HOLD : BOOTH_HOLD,
        BOOTH_RENTED : BOOTH_RENTED,
        clearBooth : clearBooth,
        createBoothGradient: function( graphic) {
            return drawing.createBoothGradient( graphic);
        },
        getBoothColor : getBoothColor,
        getBoothMinMax : getBoothMinMax,
        getFloorPlanImage : function( full) {
            return drawing.getFloorPlanImage( full);
        },
		getFloorPlanPdf: function( value) {
			return drawing.drawPdf( value);		//  check drawing === 2D !!
		},
        init : init,
		is2d : function() {
			return (drawing === twoD);
		},
        globalToFloorPlan : function( pt) {
            return drawing.globalToFloorPlan(pt);
        },
        markFavorites : markFavorites,
        newBooth : newBooth,
        outlineBooth: outlineBooth,
        redraw : function() {
            drawing.redraw( true);
        },
        removeBoothText : removeBoothText,
        sales: sales,
        saveNewBooth: saveNewBooth,
        show2d: show2d,
        show3d: show3d,
        tagBooth : tagBooth,
        unOutlineBooth: unOutlineBooth,
        updateBooth : function() {
            drawing.redraw( true);
        },
        getLocation : getLocation,
        windowResizeHandler : windowResizeHandler,
        zoomToBoothIndex : zoomToBoothIndex,
        zoomToIAmHere : zoomToIAmHere,
        parseGraphicsSQL : parseGraphicsSQL
    };
};